<template>
  <header class="app-header navbar">
    <button class="navbar-toggler mobile-sidebar-toggler d-lg-none" type="button" @click="mobileSidebarToggle">
      <span class="navbar-toggler-icon"></span>
    </button>
    <router-link :to="'/'" class="navbar-brand"></router-link>
    <button class="navbar-toggler sidebar-toggler d-md-down-none" type="button" @click="sidebarToggle">
      <span class="navbar-toggler-icon"></span>
    </button>
    <b-navbar-nav>
      
    </b-navbar-nav>
    <!-- Authenticated -->
    <template v-if="user">
      <b-navbar-nav class="ml-auto">
        <b-btn variant="secondary" size="sm" @click.prevent="$router.push({ name: 'home' })">
          ダッシュボード
        </b-btn>
        <HeaderDropdown/>
      </b-navbar-nav>
    </template>
    <!-- Guest -->
    <template v-else>
      <b-navbar-nav class="ml-auto">
        <a href="https://about.tax-seminarbook.com/lp/organizer/" target="_blank" rel="noopener noreferrer" 
          class="d-none d-lg-inline btn btn-outline-input fs-10 py-1 mr-1 mr-md-3"
          style="border-radius: 15px; color: #999"
        >
          <i class="fa fa-chevron-right mr-2"></i>セミナーBOOKに自社主催のセミナーを掲載したい方へ
        </a>
        <router-link :to="{ name: 'register' }" class="btn btn-success mr-1 mr-md-3" active-class="active">
          無料登録
        </router-link>
        <router-link :to="{ name: 'login' }" class="btn btn-outline-primary mr-1 mr-md-3" active-class="active">
          ログイン
        </router-link>
      </b-navbar-nav>
    </template>
  </header>
</template>
<script>
import { mapGetters } from 'vuex'
import HeaderDropdown from './HeaderDropdown.vue'

export default {
  name: 'c-header',
  components: {
    HeaderDropdown
  },

  data: () => ({
    appName: window.config.appName
  }),

  computed: mapGetters({
    user: 'auth/user'
  }),
  
  methods: {
    sidebarToggle (e) {
      e.preventDefault()
      document.body.classList.toggle('sidebar-hidden')
    },
    sidebarMinimize (e) {
      e.preventDefault()
      document.body.classList.toggle('sidebar-minimized')
    },
    mobileSidebarToggle (e) {
      e.preventDefault()
      document.body.classList.toggle('sidebar-mobile-show')
    },
    async logout () {
      // Log out the user.
      await this.$store.dispatch('auth/logout')

      // Redirect to login.
      this.$router.push({ name: 'login' })
    }
  }
}
</script>



// WEBPACK FOOTER //
// resources/js/components/Header/Header.vue